import React from 'react';
import { styled, LazyImage } from '@teko/ui';
import loading from '../../assets/images/loading.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div((props) => `
    width: ${props.size}px;
    height: ${props.size}px;
    position: relative;
  `);
const Logo = styled(LazyImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const StyledLazyImage = styled(LazyImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 3px;
  right: 0;
`;
const LogoLoading = (_a) => {
  var _b = _a, {
    size = 80,
    logo = ""
  } = _b, props = __objRest(_b, [
    "size",
    "logo"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    size
  }), logo && /* @__PURE__ */ React.createElement(Logo, {
    width: size / 2,
    height: size / 2,
    src: logo
  }), /* @__PURE__ */ React.createElement(StyledLazyImage, {
    width: size,
    height: size,
    src: loading
  }));
};

export { LogoLoading };
